import React from 'react'
import { Container, Message, Icon } from 'semantic-ui-react'

const PageNotFound = () => (
  <Container style={{ paddingTop: '2em' }}>
    <Message massive icon style={{ fontSize: '2rem' }}>
      <Icon name="hand spock" />
      <Message.Content>
        <Message.Header>404 - Page not found..</Message.Header>
        This isn&apos;t the page you were looking for.
      </Message.Content>
    </Message>
  </Container>
)

export default PageNotFound



// WEBPACK FOOTER //
// ./src/shared/screens/PageNotFound/index.js